import { handleActions } from 'redux-actions';
import { toggleBoxShadow } from '../actions/customizerActions';

const defaultState = {
  withBoxShadow: false,
};

export default handleActions(
  {
    [toggleBoxShadow](state) {
      return { ...state, withBoxShadow: !state.withBoxShadow };
    },
  },
  defaultState,
);
